import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {BrickSnake2000} from "../BrickSnake2000";
import {BrickSnake2000Sound} from "../sound/BrickSnake2000Sound";
import {gsap} from "gsap";
import {BrickSnake2000Symbol} from "../reels/symbols/BrickSnake2000Symbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class BrickSnake2000FreespinsResultPresentation implements FlowStatePresentation {
    private reelStopSoundIndex = 0;

    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.setSkipCallback();
            }
        });
        const newKillerCount = BrickSnake2000.model.numberOfKillers();

        if (newKillerCount != BrickSnake2000.freespinsReelView.killerCount) {
            BrickSnake2000.freespinsReelView.incrementKillerCount();
            tl.add(BrickSnake2000.transitionScreen.showSlayer());
            tl.add(() => {BrickSnake2000.soundPlayer.playSound("slayerOverlay")}, '<');
        }
        tl.add(() => flowStateController.setSkipCallback(() => tl.seek("End", false)));


        const stopAnimation = this.stopReels();

        const jurPadding = BrickSnake2000.gameFlowController.calculatePaddingDuration(stopAnimation.duration());
        tl.add(stopAnimation, `>${Math.max(jurPadding - 0.45, 0)}`);
        tl.addLabel("End");

        tl.add(() => {
            BrickSnake2000.keypadPlugin.setZeroBetSpinCounter(BrickSnake2000.model.gameData.freespinsPlayed);
            flowStateController.finish()
        }, '>0.3');
    }

    private playSymbolLandingSounds(symbols:BrickSnake2000Symbol[]):gsap.Callback {
        return () => {BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.REEL_LANDING2);};
    }

    private stopReels():gsap.core.Timeline {
        const isFastSpins = BrickSnake2000.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const stopDelay = isFastSpins ? '<' : '<0.023';

        const tl = gsap.timeline();
        for (let row = 0; row < 5; row++) {
            for (let reel = 0; reel < 5; reel++) {
                const singleReel = BrickSnake2000.freespinsReelView.getReelModel(reel, row);
                const newSymbol = BrickSnake2000.model.data.reels[reel][row];
                const reelStopTl = gsap.timeline();

                if (!singleReel.isSticky) {
                    reelStopTl.add(singleReel.stop(["X", newSymbol, "X"]));
                    reelStopTl.add(() => {
                        const sound = newSymbol == "K"
                                      ? "slayerLanding"
                                      : newSymbol == "SE"
                                      ? "eggLand"
                                      : newSymbol == "TA"
                                      ? "collectorLand"
                                      : newSymbol == "UP"
                                      ? "fsUpgradeLand"
                                      : newSymbol == "MU"
                                      ? "coinLand"
                                      : newSymbol == "WM"
                                      ? "xLand"
                                      :   (this.reelStopSoundIndex++) % 2 == 0
                                        ? "fsReelStop1"
                                        : "fsReelStop2";
                        BrickSnake2000.soundPlayer.playSound(sound);
                    });
                    //reelStopTl.add(this.playSymbolLandingSounds(singleReel.getAllVisibleSymbols()));
                    reelStopTl.add((<BrickSnake2000Symbol>singleReel.getVisibleSymbol()).getLandAnimation(), '<')
                    tl.add(reelStopTl, stopDelay);
                }
                singleReel.unmarkAsSticky();
            }
        }
        tl.add(() => {
            BrickSnake2000.soundPlayer.stopSound(BrickSnake2000Sound.REEL_SPINNING_FS);
        }, '<');
        return tl;
    }
}